import * as React from "react";
import type { SVGProps } from "react";
const SvgStop02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17.9999 2.3999H5.9999C4.01168 2.3999 2.3999 4.01168 2.3999 5.9999V17.9999C2.3999 19.9881 4.01168 21.5999 5.9999 21.5999H17.9999C19.9881 21.5999 21.5999 19.9881 21.5999 17.9999V5.9999C21.5999 4.01168 19.9881 2.3999 17.9999 2.3999Z"
    />
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8.3999 9.7499C8.3999 9.00432 9.00432 8.3999 9.7499 8.3999H14.2499C14.9955 8.3999 15.5999 9.00432 15.5999 9.7499V14.2499C15.5999 14.9955 14.9955 15.5999 14.2499 15.5999H9.7499C9.00432 15.5999 8.3999 14.9955 8.3999 14.2499V9.7499Z"
    />
  </svg>
);
export default SvgStop02;
